module.exports = __webpack_public_path__ + "8de00b420b58a32431f0bc464fd94dc1.svg";